import { select, selectAll } from 'd3-selection';
import { scaleLinear, scaleTime } from 'd3-scale';
import { axisRight, axisBottom } from 'd3-axis';
import { max, min, range, extent, ticks } from 'd3-array';
import { timeParse, timeFormat } from 'd3-time-format';
import { line } from 'd3-shape';

export default Object.assign({}, {
    select,
    selectAll,
    scaleLinear,
    scaleTime,
    axisRight,
    axisBottom,
    line,
    max,
    min,
    range,
    extent,
    ticks,
    timeFormat,
    timeParse,
});
